import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';

import reportWebVitals from './reportWebVitals';
import {UserContextProvider} from "./contexts/user";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import { Outlet } from "react-router-dom";
import "@hackernoon/pixel-icon-library/fonts/iconfont.css";

let config;
console.log(`👨‍💻👨‍💻 You're in the ${process.env.REACT_APP_ENV} env 👨‍💻👨‍💻`);
if (process.env.NODE_ENV === "test") {
  config = {
    apiKey: "AIzaSyBp4D3IFqqrXauB0cD9eyNb_QaLn9Rxwzk",
    authDomain: "hackernoon-test.firebaseapp.com",
    databaseURL: "https://hackernoon-test.firebaseio.com",
    projectId: "hackernoon-test",
    storageBucket: "hackernoon-test.appspot.com",
    messagingSpenderId: "653215936717",
  };
} else if (process.env.REACT_APP_ENV === "development") {
  config = {
    apiKey: "AIzaSyCVDCIrU3SXP25fHLQi_JKTU11Qq96iFdw",
    authDomain: "hackernoon-dev.firebaseapp.com",
    databaseURL: "https://hackernoon-dev.firebaseio.com",
    projectId: "hackernoon-dev",
    storageBucket: "hackernoon-dev-ohyeah",
    messagingSenderId: "187734907040",
    appId: "1:187734907040:web:8eb941fc976cba3d",
  };
} else {
  config = {
    apiKey: "AIzaSyCjRAcAgsxlffnuZNIr4zOGaIsEKKEaJCg",
    authDomain: "app.hackernoon.com",
    databaseURL: "https://hackernoon-app.firebaseio.com",
    projectId: "hackernoon-app",
    storageBucket: "hackernoon",
    messagingSenderId: "521962009898",
    measurementId: "G-ECJJ2Q2SJQ",
  };
}

firebase.initializeApp(config);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE);
//firebase.firestore().useEmulator("localhost", 8004);
firebase.firestore().settings({ignoreUndefinedProperties: true, experimentalAutoDetectLongPolling: true, merge: true});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <UserContextProvider>
    <App />
  </UserContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
